import { McpServer } from "@modelcontextprotocol/sdk/server/mcp.js";

import packageJson from "../package.json" with { type: "json" };
import {
  registerListPagesTool,
  registerListReleasesTool,
  registerListStyleguidesTool,
} from "./tools/styleguide.js";
import {
  registerGetPageAssetTool,
  registerGetPageTool,
  registerGetPageImagesTool,
  registerSearchPagesTool,
} from "./tools/page.js";
import {
  registerGetTokensTool,
  registerListTokenSetsTool,
} from "./tools/token.js";
import { registerLintCodeTool } from "./tools/lint.js";
import { recommendSummarizePagePrompt } from "./prompts/page.js";
import { registerRecommendPagesPrompt } from "./prompts/styleguide.js";
import { ServerContext } from "./types/server.js";
import { SERVER_INSTRUCTIONS } from "./instructions.js";

export function createServer(
  context: ServerContext = {
    connectionMode: "local",
    features: {},
  },
) {
  const server = new McpServer(
    {
      name: "zeroheight",
      version: packageJson.version,
    },
    {
      instructions: SERVER_INSTRUCTIONS,
    },
  );

  // Register tools
  if (context.connectionMode !== "remote_single_styleguide") {
    registerListStyleguidesTool(server);
  }

  [
    registerListPagesTool,
    registerListReleasesTool,
    registerGetPageTool,
    registerGetPageAssetTool,
    registerGetPageImagesTool,
    registerSearchPagesTool,
    registerListTokenSetsTool,
    registerGetTokensTool,
    registerLintCodeTool,
  ].forEach((fn) => fn(server, context));

  // Register all prompts
  registerRecommendPagesPrompt(server, context);
  recommendSummarizePagePrompt(server);

  return server;
}
